import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import {findIn} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as filterOverlay from './scripts/filter-overlay';
filterOverlay.init();

import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multipleSelectDropdown from './scripts/multiselect-dropdown';
multipleSelectDropdown.init();

const isDesktop = matchMedia('(min-width: 768px)').matches;
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnChange: isDesktop,
    addUrlParams: true
});

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('[data-bs-toggle="dropdown"]',function (element) {
    new Dropdown(element);
});

import * as conditionalForm from './scripts/conditional-form';
conditionalForm.init();

import * as dropdownTracking from './scripts/dropdown-tracking';
dropdownTracking.init();